import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class FluidsFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>

        <div style = {{paddingBottom: 40}}>
        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Density</TableRowColumn>
        <TableRowColumn> <img style = {{width: 400}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Specific Gravity</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Bouyant Force</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Hydrostatic Pressure</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Pascal's Law</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/5.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Poiseuille’s Law</TableRowColumn>
        <TableRowColumn> <img style = {{width: 400}} src = {require("./Formulas/6.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Continuity equation</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/7.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Bernoulli’s equation</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/8.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Fluid Weight</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/9.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Absolute pressure</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/10.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 300}}>Pressure</TableRowColumn>
        <TableRowColumn><img style = {{width: 400}} src = {require("./Formulas/11.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>

  </div>


      </MuiThemeProvider>

    );
  }
}

export default FluidsFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Fluids/FluidsFormulas.js